import HttpRequestService from "../services/HttpRequestService";


const FAQService = {};

//API for get all data
FAQService.PostUpsertFAQ = function(payload) {
  return HttpRequestService.post("/UpsertFAQ", payload)
}

FAQService.getFAQList = function () {
  return HttpRequestService.get("/GetFAQList");
};
export default FAQService;
